import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'drme-our-services',
    templateUrl: './our-services.component.html',
    styleUrls: ['./our-services.component.css']
})
export class OurServicesComponent implements OnInit {

    constructor(public router: Router) { }

    ngOnInit(): void {
    }

    public onSchedule() {
        window.location.href = 'http://apt.drme.ir';
    }

    public onPresc() {
        window.location.href = 'http://ep.drme.ir';
    }
}
